module.exports = __webpack_public_path__ + "static/landing-background-c553d5dcb9a7c502edb5a7fb8fe32708.jpg";